import React, { useState } from 'react'
import apiClient from '../../utils/apiclient'
import { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import Menu from "../../components/Menu/Index"
import Orders from "../../components/orders/index"
import Subscriptionsorders from "../../components/SubscriptionOrders/index"
import Subscription from "../../components/subscriptions/Index"
import SubscriptionHistory from "../../components/Subscription History/Index"
import Navbar from "../../components/NavBar/Index"
import RestaurantDetails from "../../components/RestaurantDetails/index"
import RestaurantRatings from '../../components/Ratings/RestaurantRatings'
import TimeSlots from '../../components/TimeSlots/Index'
import MealPlan from '../../components/MealPLan/Index'
import Highlights from '../../components/Highlights/Index'
import MealVariablesPage from "../../components/MealVariables/Index";

const   Index = () => {
  const navigate=useNavigate()
  useEffect(() => {
     if (!localStorage.getItem("bentoAdmin")) {
       navigate("/login")
     }
   }, [navigate])
 
    const {id}=useParams();
    const [restaurantdetails,SetRestaurantDetails]=useState([])
    const[menu,SetMenu] = useState([]);
    const[orders,SetOrders] = useState([]);
    const[subscriptionsorders,Setsubscriptionsorders] = useState([]);
    const[subscriptions,Setsubscriptions] = useState([]);
    const[subscriptionHistory,SetsubscriptionHistory] = useState([]);
    const [activeSession,SetactiveSession]=useState("menu");
    const [weekmeals,SetweekMeals]=useState([])
    const [ratings,setRatings]= useState([])
    const [timeslots,setTimeSlots]= useState([])
    const [mealplan,SetMealplan] = useState([])
    
    // console.log(id)
    
        const fetchData=async()=>{
            try{
                const menu = await apiClient.get (`/items/${id}`);
                                SetMenu(menu.data);
                console.log("dataffetched");

                const orders = await apiClient.get (`/orders/${id}`);
                const subscriptionsorders = await apiClient.get (`/subscriptionOrders/${id}`);
                const subscriptions = await apiClient.get (`/subscriptions/${id}`);
                const subscriptionHistory = await apiClient.get (`/subscriptionHistory/${id}`);
                const weekmeals = await apiClient.get(`restaurant/mealsaddedtoday/${id}`)
                const restaurantdetails=await apiClient.get(`/restaurantInfo/${id}`)
                const ratings=await apiClient.get(`/restaurant/rating/${id}`)
                const timeslots=await apiClient.get(`/get/timeslot/${id}`)
                
                SetOrders(orders.data)
                Setsubscriptionsorders(subscriptionsorders.data)
                Setsubscriptions(subscriptions.data)
                SetsubscriptionHistory(subscriptionHistory.data)
                SetweekMeals(weekmeals.data)
                SetRestaurantDetails(restaurantdetails.data)    
                setRatings(ratings.data)            
                setTimeSlots(timeslots.data)            
                console.log(ratings.data);


                
            }
            catch (err) {
        console.error("Something went wrong",err);
      }
        }
        useEffect(()=>{
        fetchData();
    },[id])
  return (
    <div className='flex min-h-full w-full flex-col items-center overflow-y-auto px-2 pb-8 text-center'>
       <div className='justify-between w-screen'>
       </div>
    <div className='flex w-full flex-col justify-center items-center text-center'>
        <div className='flex w-full flex-nowrap gap-4 mb-6 justify-start items-center mt-6 overflow-x-auto px-4 py-2 whitespace-nowrap'>
            <button className='border-2 px-4 bg-blue-400 min-w-max' onClick={()=>{SetactiveSession("menu")}}>Menu</button>
            <button className='border-2 px-4 bg-blue-400 min-w-max' onClick={()=>{SetactiveSession("orders")}}>Orders</button>
            <button className='border-2 px-4 bg-blue-400 min-w-max' onClick={()=>{SetactiveSession("Subscription orders")}}>Subscription orders</button>
            <button className='border-2 px-4 bg-blue-400 min-w-max' onClick={()=>{SetactiveSession("Subscriptions")}}>Subscriptions</button>
            <button className='border-2 px-4 bg-blue-400 min-w-max' onClick={()=>{SetactiveSession("SubscriptionHistory")}}>Subscriptions history</button>
            <button className='border-2 px-4 bg-blue-400 min-w-max' onClick={()=>{SetactiveSession("WeekMealsToday")}}>Week Meals Today</button>
            <button className='border-2 px-4 bg-blue-400 min-w-max' onClick={()=>{SetactiveSession("restaurantdetails")}}>Restaurant details</button>
            <button className='border-2 px-4 bg-blue-400 min-w-max' onClick={()=>{SetactiveSession("restaurantratings")}}>Restaurant Rating</button>
            <button className='border-2 px-4 bg-blue-400 min-w-max' onClick={()=>{SetactiveSession("timeslots")}}>Time Slots</button>
            <button className='border-2 px-4 bg-blue-400 min-w-max' onClick={()=>{SetactiveSession("mealplan")}}>Meal Plans</button>
            <button className='border-2 px-4 bg-blue-400 min-w-max' onClick={()=>{SetactiveSession("highlights")}}>Highlights</button>
            <button className='border-2 px-4 bg-blue-400 min-w-max' onClick={()=>{SetactiveSession("mealvariables")}}>Meal Variables</button>
        </div>
    </div>

        
        


        {/* <h1 className='text-3xl'>menu</h1> */}
      {activeSession==="menu" && <Menu data={menu} id={id} activesessione={"menu"} refreshData={fetchData}/>}
      {/* <h1 className='text-3xl'>orders</h1> */}
      {activeSession==="orders" &&<Orders data={orders}/>}
      {/* <h1 className='text-3xl'>subscriptionsorders</h1> */}
      {activeSession==="Subscription orders" && <Subscriptionsorders data={subscriptionsorders} />}
      {/* <h1 className='text-3xl'>subscriptions</h1> */}
      {activeSession==="Subscriptions" &&<Subscription data={subscriptions} />}
      {/* <h1 className='text-3xl'>subscription History</h1> */}
      {activeSession==="SubscriptionHistory" &&<SubscriptionHistory data={subscriptionHistory} />}
      {activeSession==="WeekMealsToday"&& <Menu data={weekmeals} id={id} activesessione={"WeekMealsToday"}/>}
            {activeSession==="restaurantdetails"&& <RestaurantDetails data={restaurantdetails} />}

            {activeSession==="restaurantratings"&& <RestaurantRatings data={ratings} />}
            {activeSession==="timeslots"&& <TimeSlots data={id} />}
            {activeSession==="mealplan"&& <MealPlan data={id} />}
            {activeSession==="highlights"&& <Highlights data={id} />}
            {activeSession==="mealvariables"&& <MealVariablesPage data={id} />}

    
      
    </div>
  )
}

export default Index
